import React from "react";
import PostList from "./components/PostList";
import Post from "./components/Post";
import HomePage from "./components/HomePage";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import logoTurned from "./images/logo-rotate.svg";

function App() {
  const location = useLocation();

  return (
    <>
      <div className=" sm:flex justify-evenly">
        <div className="z-10 pt-1 archivo w-screen text-center text-5xl etra-red-bg text-white nav fixed top-0 sm:hidden">
          <div
            onClick={() => {
              document.documentElement.style.setProperty(
                "--main-bg",
                "#da4f3a"
              );
            }}
          >
            <Link to="/">ETRA</Link>
          </div>
        </div>
        <div className="h-screen items-center justify-center hidden sm:flex">
          <Link to="/">
            <img
              alt="ETRA"
              onClick={() => {
                document.documentElement.style.setProperty(
                  "--main-bg",
                  "#da4f3a"
                );
              }}
              className="logo block"
              src={logoTurned}
            />
          </Link>
        </div>
        <div id="list" className="w-screen">
          <div className="h-screen overflow-auto hidden sm:block">
            <PostList location={location.pathname} />
          </div>
        </div>
        <div
          id="content"
          className=" mt-12 sm:mx-0 sm:mt-0 sm:h-screen overflow-auto"
        >
          <TransitionGroup component={null}>
            <CSSTransition key={location.key} classNames="fade" timeout={300}>
              <Routes>
                <Route
                  exact
                  path="/"
                  element={
                    <>
                      <div className="sm:hidden">
                        <PostList location={location.pathname} />
                      </div>
                      <div className="hidden sm:flex justify-center items-center h-screen">
                        <HomePage />
                      </div>
                    </>
                  }
                />
                <Route path="/:authorSlug/:slug" element={<Post />} />
              </Routes>
            </CSSTransition>
          </TransitionGroup>
        </div>
      </div>
    </>
  );
}

export default App;
